/**
 * Utility functions for WhatsApp integration
 */

// WhatsApp contact number (without country code prefix in the function, added in URL)
const WHATSAPP_NUMBER = '917893092211';

/**
 * Opens WhatsApp chat with predefined number and message
 * @param {string} message - Custom message to send (optional)
 */
export const openWhatsAppChat = (message = 'Hi, I am interested in your properties. Please share more details.') => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
};

/**
 * Opens WhatsApp chat with property-specific message
 * @param {object} property - Property object with details
 */
export const openWhatsAppChatForProperty = (property) => {
    const message = `Hi, I am interested in the ${property.type || 'property'} located in ${property.location || 'your area'}. Property ID: ${property.id || 'N/A'}. Please share more details.`;
    openWhatsAppChat(message);
};

/**
 * Opens WhatsApp chat with inquiry message
 * @param {string} inquiryType - Type of inquiry (residential, commercial, agricultural)
 */
export const openWhatsAppChatForInquiry = (inquiryType) => {
    const message = `Hi, I am interested in ${inquiryType} properties. Please share available options and details.`;
    openWhatsAppChat(message);
};

export default {
    openWhatsAppChat,
    openWhatsAppChatForProperty,
    openWhatsAppChatForInquiry
};